// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_n8-5";
export var filledCircle = "_n8-4";
export var historyEntry = "_n8-3";
export var messageSideLeft = "_n8-1";
export var messageSideRight = "_n8-2";
export var orderTrackingCarouselWrapper = "_n8-6";
export var orderTrackingInfoContainer = "_n8-0";